import { render, staticRenderFns } from "./ContestJudgeComponent.vue?vue&type=template&id=ddccc956"
import script from "./ContestJudgeComponent.vue?vue&type=script&lang=js"
export * from "./ContestJudgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports